"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const StyledMainContainer_1 = require("components/Dashboard/StyledMainContainer");
const ErrorFallback = ({ error }) => (react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, null,
    react_1.default.createElement(polaris_1.Banner, { title: 'Oops! Something went wrong.', tone: 'critical' },
        react_1.default.createElement("p", { className: 'error-banner-msg' }, error.message))));
exports.default = ErrorFallback;
